app.controller('QuickSignUp', [
  '$scope',
  '$filter',
  'quickSingUpService',
  'trackerService',
  'RecaptchaService',
  function (
    $scope,
    $filter,
    quickSingUpService,
    trackerService,
    RecaptchaService,
  ) {
    $scope.policy = false;
    $scope.getInformation = true;
    $scope.phoneValidate = false;
    $scope.errorMessage = '';
    $scope.state = {
      isLoading: false,
      submitClicked: false,
    };

    $scope.telChange = function () {
      if (validatePhone()) {
        $scope.phoneValidate = true;
        $scope.errorMessage = '';
      } else {
        $scope.phoneValidate = false;
        if ($scope.phone) {
          $scope.errorMessage = $filter('translate')(
            'user.quick_signup.error.format',
          );
        }
      }
    };

    $scope.submit = function () {
      $scope.state.submitClicked = true;

      if (!$scope.phoneValidate) {
        return;
      }
      var subscriptionTags = $scope.getInformation ? ['marketing.news'] : [];
      quickSingUpService
        .signUp(
          $scope.phone,
          $('.intl-tel-input').intlTelInput('getSelectedCountryData').dialCode,
          subscriptionTags,
        )
        .then(function (data) {
          trackerService.fbSignup(data.data._id);
          window.location.href =
            '/users/sign_up/quick/' +
            data.data._id +
            '/edit?country_calling_code=' +
            $('.intl-tel-input').intlTelInput('getSelectedCountryData')
              .dialCode +
            '&mobile_phone=' +
            $scope.phone;
        })
        .catch(function (error) {
          $scope.serverErrorMessage = error.data.error_messages;
          $('html, body').animate(
            {
              scrollTop: $('.title-text').offset().top + 20,
            },
            200,
          );
        })
        .finally(function () {
          RecaptchaService.reset('quick-sign-up-recaptcha');
        });
    };

    var validatePhone = function () {
      var country = $('.intl-tel-input').intlTelInput('getSelectedCountryData')
        .iso2;
      if (country === 'hk') {
        return /^[4-9]{1}\d{7}$/.test($scope.phone);
      }
      return intlTelInputUtils.isValidNumber($scope.phone, country);
    };
  },
]);
